<template>
    <div>
        <b-form-row>
            <b-col>
                <h5>Record Payment</h5>
            </b-col>
        </b-form-row>
        <hr>
        <b-form-row class="review-section">
            <b-col>
                <span>Account Manager Comments</span>
                <br>
                <b-form-textarea
                    v-model="form.actor_comment"
                    :disabled="!isPurchasePayable"
                    :rows="5"
                    placeholder="Comments are required to enable 'Pay' button below"
                />
            </b-col>
        </b-form-row>

        <b-form-row v-if="!isPurchasePayable" class="review-section">
            <span class="review-section-header">Payment Status:</span>
            <b-col>
                <b-badge v-if="hasBeenPaid" variant="ace-green" style="font-size: 1.1em;">
                    <fa-icon :icon="['fal', 'thumbs-up']" />
                    {{ paidButtonLabel }}
                </b-badge>

                <b-badge v-else variant="info" style="font-size: 1.1em;">
                    Awaiting Payment
                </b-badge>
            </b-col>
        </b-form-row>

        <b-form-row v-else class="review-section">
            <b-col cols="3">
                <b-button
                    id="popover-pay-button"
                    variant="ace-green"
                    :loading="isPaying"
                    :disabled="hasNoComment"
                    @click.stop="onShowPayPopover('popover-pay-button')"
                >
                    <fa-icon :icon="['fal', 'thumbs-up']" />
                    {{ paidButtonLabel }}
                </b-button>
            </b-col>
        </b-form-row>

        <!-- Pay Purchase Pop -->
        <b-popover :target="'popover-pay-button'">
            <template slot="title" class="title-class">
                <strong>PAY PURCHASE</strong>
            </template>
            <template slot="default">
                <b-form-row>
                    <b-col>
                        <p>
                            Click the <strong>Pay</strong> button, if you are ready to mark this
                            Purchase as Paid and notify the applicant.
                        </p>
                    </b-col>
                </b-form-row>
            </template>
            <b-form-row>
                <b-col ref="payButton" cols="6">
                    <b-button
                        size="sm"
                        block
                        class="cancel-button"
                        @click="onClosePayPopover('popover-pay-button')"
                    >
                        <strong>Cancel</strong>
                    </b-button>
                </b-col>
                <b-col cols="6">
                    <b-button size="sm"
                              block
                              variant="budget"
                              @click="payPurchase"
                    >
                        <strong>PAY</strong>
                    </b-button>
                </b-col>
            </b-form-row>
        </b-popover>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import { Log } from '$Shared/@arc/vue-arc';

export default {
    name: 'PurchasePay',

    props: {
        applicationId: { type: [String, Number], required: true },
        proposalId: { type: [String, Number], required: true },
        costId: { type: [String, Number], required: true },
        purchaseId: { type: [String, Number], required: true },
        formDisabled: { type: Boolean, default: false },
    },

    data() {
        return {
            form: {
                actor_comment: null,
            },
            actionTaken: null,
            isPaying: false,
            backgroundColor: '#006438',
            dropdownOptions: [],
        };
    },

    computed: {
        ...mapState('purchase/form', {
            purchaseForm: (state) => state,
        }),

        ...mapGetters({
            isPurchasePayable: 'purchase/isPayable',
            purchaseActionTaken: 'purchase/actionTaken',
        }),

        payload() {
            return {
                ...this.form,
                costId: this.purchaseForm.cost_id,
                purchaseId: this.purchaseForm.purchase_id,
            };
        },

        hasBeenPaid() {
            return this.actionTaken === 'pay' && !this.isPurchasePayable;
        },

        paidButtonLabel() {
            return this.hasBeenPaid ? 'Purchase Paid' : 'Pay this Purchase';
        },

        purchasePaymentStatusBadgeOptions() {
            switch (this.actionTaken) {
                case 'pay':
                    return { status: 'Paid', variant: 'success' };
                default:
                    return { status: 'Awaiting Payment', variant: 'info' };
            }
        },

        hasNoComment() {
            return this.form.actor_comment === null || this.form.actor_comment === '';
        },
    },

    async created() {
        if (!this.isPurchasePayable) {
            // this.form.actor_comment = this.purchasePayComment;
            this.actionTaken = this.purchaseActionTaken;
        }
    },

    methods: {
        ...mapActions(['fetchRolesForOa', 'assignToUser']),

        async payPurchase() {
            this.actionTaken = 'pay';
            this.isPaying = true;

            const response = await this.$store.dispatch('purchase/review/pay', {
                ...this.payload,
            });
            this.isPaying = false;
            Log.debug(response, 'COMPONENT:' + this.name + ' -> PAY PURCHASE response: ');

            this.$root.$emit('bv::hide::popover');
        },

        onShowPayPopover(target) {
            this.$root.$emit('bv::hide::popover', target);
            this.$root.$emit('bv::show::popover', target);
        },

        onClosePayPopover(target) {
            this.$root.$emit('bv::hide::popover', target);
        },
    },
};
</script>
